import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { STUDIO_INQUIRY_CONSTANTS } from '../../../constants/core.constant';

interface StudioService {
  id: string;
  name: string;
  detail: string;
}

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-studio-inquiry-modal',
    templateUrl: './studio-inquiry-modal.component.html',
    styleUrls: ['./studio-inquiry-modal.component.scss'],
    standalone: false
})
export class StudioInquiryModalComponent implements OnInit {
  /** Services chosen earlier, so editing from the review keeps the selection */
  @Input() preselectedServices: StudioService[] = [];
  @Output() servicesSelected = new EventEmitter<StudioService[]>();
  constants = STUDIO_INQUIRY_CONSTANTS;
  serviceColumns: StudioService[][] = [
    STUDIO_INQUIRY_CONSTANTS.servicesColumnOne,
    STUDIO_INQUIRY_CONSTANTS.servicesColumnTwo,
  ];
  servicesForm!: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    const chosen = this.preselectedServices?.map((service) => service.id) || [];
    const controls: Record<string, boolean[]> = {};
    this.allServices.forEach((service) => {
      controls[service.id] = [chosen.includes(service.id)];
    });
    this.servicesForm = this.formBuilder.group(controls);
  }

  /**
   * allServices() - Flattens both service columns into a single list
   * @returns the full list of selectable studio services
   */
  get allServices(): StudioService[] {
    return this.serviceColumns.flat();
  }

  /**
   * selectedServices() - Collects the services the user has checked
   * @returns the checked studio services
   */
  get selectedServices(): StudioService[] {
    return this.allServices.filter((service) => this.servicesForm?.get(service.id)?.value);
  }

  /**
   * onNext() - Emits the selected services and closes the modal
   */
  onNext(): void {
    this.servicesSelected.emit(this.selectedServices);
    this.activeModal.close(this.selectedServices);
  }

  /**
   * closeModal() - Dismisses the modal without keeping the selection
   */
  closeModal(): void {
    this.activeModal.dismiss();
  }
}
